import { marketplaceConstants } from "../_constants";

export function allMarketplaces(state = {}, action) {
  switch (action.type) {
    case marketplaceConstants.FETCH_ALL_MARKETPLACE_CARDS_REQUEST:
      return {
        loading: true,
      };
    case marketplaceConstants.FETCH_ALL_MARKETPLACE_CARDS_SUCCESS:
      return {
        item: action.data,
      };
    case marketplaceConstants.FETCH_ALL_MARKETPLACE_CARDS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
export function marketplaceConfigSubmission(state = {}, action) {
  switch (action.type) {
    case marketplaceConstants.CONFIGURE_MARKETPLACE_REQUEST:
      return {
        loading: true,
      };
    case marketplaceConstants.CONFIGURE_MARKETPLACE_SUCCESS:
      return {
        success: true,
        data: action.data,
      };
    case marketplaceConstants.CONFIGURE_MARKETPLACE_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function activeCloudStorageByType(state = {}, action) {
  switch (action.type) {
    case marketplaceConstants.ACTIVE_CLOUD_STORAGE_REQUEST:
      return {
        loading: true,
      };
    case marketplaceConstants.ACTIVE_CLOUD_STORAGE_SUCCESS:
      return {
        item: action.data,
      };
    case marketplaceConstants.ACTIVE_CLOUD_STORAGE_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function listInfraByMarketplaceId(state = {}, action) {
  switch (action.type) {
    case marketplaceConstants.FETCH_INFRA_BY_MARKETPLACE_ID_REQUEST:
      return {
        loading: true,
      };
    case marketplaceConstants.FETCH_INFRA_BY_MARKETPLACE_ID_SUCCESS:
      return {
        item: action.data,
      };
    case marketplaceConstants.FETCH_INFRA_BY_MARKETPLACE_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
